import { render, staticRenderFns } from "./LightFlashingPatterns.vue?vue&type=template&id=1187f561&"
import script from "./LightFlashingPatterns.vue?vue&type=script&lang=js&"
export * from "./LightFlashingPatterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports